(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'SegmentEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// Serialized form data
		var serial;

		// Array of objects from form inputs
		var filters;

		// serialize form and call ajax with serialized data
		serial = $form.serializeArray();

		// load the filters and client count if editing a segment
		if ($("#segmentedit-id").val() > 0) {
			filters = makeFiltersArray($form);
			setFilters(filters);
			getCount(serial);
		}

		$('#segmentedit-assign').on('change', function assignClients() {
			if ($(this).is(':checked')) {
				$('#keep-clients-row').removeClass('hidden');
			} else {
				$('#keep-clients-row').addClass('hidden');
			}
		});

		$('#segmentedit-future_credit_vendor_ids').on(
			'change',
			function toggleFutureCreditType() {
				if ($(this).val().length > 0) {
					if ($("#future-credits-row optgroup[label='Air'] option:selected").length > 0) {
						$('#segmentedit-future_credit_type').val('credit');
						$("#segmentedit-future_credit_type option[value='deposit'").attr('disabled', true);
					} else {
						$("#segmentedit-future_credit_type option[value='deposit'").attr('disabled', false);
					}

					$('#future-credit-type-row').removeClass('hidden');
				} else {
					$('#future-credit-type-row').addClass('hidden');
					$('#segmentedit-future_credit_type').val('');
				}
			}
		);

		if ($('.airport-search').length) {
			Adzuki.Typeahead(
				'.airport-search',
				'/Airports/search',
				function select(item) {
					$form.find('#segmentedit-air_gateway_id').val(item.id).trigger('change');
				},
				function template(item) {
					var html = '';
					    html += item.name;

					return html;
				}
			);
		}

		if ($('.group-search').length) {
			Adzuki.Typeahead(
				'.group-search',
				'/Groups/searchGroupsTypeahead',
				function select(item) {
					if (item.type === 'cruise') {
						$form.find('#segmentedit-group_id').val(item.id).trigger('change');
					}
					if (item.type === 'package') {
						$form.find('#segmentedit-tour_group_id').val(item.id).trigger('change');
					}
					if (item.type === 'lodging') {
						$form.find('#segmentedit-hotel_group_id').val(item.id).trigger('change');
					}
				},
				function template(item) {
					var html = '';
					    html += item.name;

					if (item.number) {
						if (item.name) {
							html += ' ';
						}

						html += '#'+item.number;
					}

					return html;
				}
			);
		}

		$("#segmentedit-air_gateway")
			.on(
				'click',
				function clear(e) {
					$(this).val('');
					$('#segmentedit-air_gateway_id').val('');
					$form.trigger('change');
				}
			)
		;

		$("#segmentedit-group")
			.on(
				'click',
				function clear(e) {
					$(this).val('');
					$('#segmentedit-group_id').val('');
					$('#segmentedit-tour_group_id').val('');
					$('#segmentedit-hotel-group_id').val('');
					$form.trigger('change');
				}
			)
		;

		$('form[name=SegmentEdit]')
			.on(
				'change dp.change',
				function change(e) {
					// create array of objects from form inputs then send to DOM for display
					filters = makeFiltersArray($form);
					setFilters(filters);
					// serialize form and call ajax with serialized data
					if (e.target.id === 'segmentedit-group') { return; }
					serial = $form.serializeArray();
					getCount(serial);
				}
			)
		;

		$('.reset')
			.on(
				'click',
				function reset(e) {
					e.preventDefault();

					$form.find('input[type=text], input[type=hidden], input[type=date], input[type=number]').not('#segmentedit-name').val('');
					$form.find('.radio-group .default-value').button('toggle');

					$form.find('select').selectpicker('deselectAll');

					filters = makeFiltersArray($form);
					setFilters(filters);

					serial = $form.serializeArray();
					getCount(serial);
				}
			)
		;

		// onload, if "yes" selected on load for certain radio buttons, disable radio buttons that are opposed to that condition
		// for example "Only Clients With a Phone Number" vs "Only Clients Without a Phone Number"
		$('[data-opposite]').each(function opps() {
			var $self    = $(this),
			    opposite = $self.data('opposite');

			if ($self.is(":checked") && $self.val() === 'yes') {
				toggleRelatedRadio($self, opposite);
			}
		});

		$('[data-opposite]').change(function disableOpposite() {
			toggleRelatedRadio($(this), $(this).data('opposite'));
		});

		// if fields that require an address are changed, disable "Only Clients Without an Address"
		$('.disable-no-address').change(function disableNoAddress() {
			toggleWithoutAddress();
		});

		// if "Only Clients Without an Address" changed
		$('.disable-address').change(function disableAddress() {
			toggleAddressDependent($(this));
		});

		toggleWithoutAddress();

		toggleAddressDependent($("input[name='form_component_data[SegmentEdit][without_address_only]']:checked"));

		// look at "Only Clients Without an Address" value and determine if other inputs need to be disabled
		function toggleAddressDependent($radio)
		{
			var $ui_btn = $('.with_address_only .btn-radio'), // opposite radio buttons
			    $inputs = $ui_btn.find("input[type='radio']"),
			    disable = false;

			if ($radio.val() === 'yes') {
				disable = true;
				$inputs.children().eq(1).trigger('click');
				$ui_btn.addClass('disabled');
			} else {
				$ui_btn.removeClass('disabled');
			}

			$inputs.attr('disabled', disable);
			$('#segmentedit-city').attr('disabled', disable);
			$('#segmentedit-state').attr('disabled', disable);
			$('#segmentedit-zip_code').attr('disabled', disable);
			$('#segmentedit-air_gateway').attr('disabled', disable);
			$('#segmentedit-air_gateway_id').attr('disabled', disable);

			// specifically for state multi-select
			$('.disable-no-address').find('.dropdown-toggle').toggleClass('disabled');
		}

		// disable/enable other inputs which contradict the current input
		function toggleRelatedRadio($main, related_class) {
			var $ui_btn = $('.' + related_class + ' .btn-radio'),
				$inputs = $ui_btn.find("input[type='radio']");

			if ($main.val() === 'yes') {
				// clicks "No" radio button
				$inputs.children().eq(1).trigger('click');

				$ui_btn.addClass('disabled');
				$inputs.attr('disabled', true);
			} else {
				$ui_btn.removeClass('disabled');
				$inputs.attr('disabled', false);
			}
		}

		// if an input, which relies on a client address, has a value, or if "Only Clients With Addresses" is set to "Yes", disable "Only Clients Without an Address"
		// otherwise enable "Only Clients Without an Address"
		function toggleWithoutAddress()
		{
			var any_values   = false,
			    $ui_btn      = $('.without_address_only .btn-radio'),
			    $inputs      = $ui_btn.find("input[type='radio']"),
			    only_address = $("input[name='form_component_data[SegmentEdit][with_address_only]']:checked").val();

			if (only_address === 'yes') {
				any_values = true;
			} else {
				// if city, state, zip code or airport gateway has a value
				$('.disable-no-address:not(input[type="radio"])').each(function opps() {
					if ($(this).val().length > 0) {
						any_values = true;
						return false;
					}
				});
			}

			// one of the address fields is present, set to "No" and disable "Only Clients Without an Address"
			if (any_values === true) {
				$inputs.children().eq(1).trigger('click');

				$ui_btn.addClass('disabled');
				$inputs.attr('disabled', true);
			// enable "Only Clients Without an Address"
			} else {
				$ui_btn.removeClass('disabled');
				$inputs.attr('disabled', false);
			}
		}

		function makeFiltersArray(form) {
			var inputs     = form.find('input[type=text], select');
			var options    = form.find('input[type=radio]:checked, input[type=checkbox]:checked, input[type=number], input[type=date]');
			var title      = '';
			var filters    = [];
			var filter;
			var values;

			// Loops through all text & select inputs and creates array of objects based on inputs passed in
			$(inputs)
				.each(
					function createFiltersArray() {
						var $self = $(this);
						filter = {};
						values = [];

						if ($self.attr('data-title')) {
							title = $self.attr('data-title');

							// If select box, add all selected options to array
							if ($self.attr('type') === 'select') {
								$self.find('option:selected')
									.each(
										function addSelectedText() {
											if ($(this).val() !== '') {
												values.push($(this).text());
											}
										}
									)
								;

								filter.title  = title;
								filter.values = values;
							}

							// If text input, just add value to array
							if ($self.attr('type') === 'text') {
								if ($self.val()) {
									values.push($self.val());

									filter.title  = title;
									filter.values = values;
								}
							}

							// If text input, just add value to array
							if ($self.attr('type') === 'number') {
								if ($self.val()) {
									values.push($self.val());

									filter.title  = title;
									filter.values = values;
								}
							}

							if (!$.isEmptyObject(filter)) {
								filters.push(filter);
							}
						}
					}
				)
			;

			// clear values
			filter = {};
			values = [];

			// Loops through selected checkboxes and radio buttons and adds them to filters array as a single object
			$(options)
				.each(
					function addOptions() {
						var $self = $(this);

						if ($self.attr('data-title') && $self.val()) {
							if ($self.attr('type') === 'radio') {
								values.push($self.attr('data-title'));
							}
							if ($self.attr('type') === 'checkbox') {
								values.push($self.attr('data-title'));
							}
							if ($self.attr('data-range') === 'min') {
								values.push( $self.attr('data-title') + ' > ' + $self.val() );
							}
							if ($self.attr('data-range') === 'max') {
								values.push( $self.attr('data-title') + ' < ' + $self.val() );
							}
						}
					}
				)
			;

			filter.title  = 'Options';
			filter.values = values;

			if (!$.isEmptyObject(filter)) {
				filters.push(filter);
			}

			return filters;
		}

		function getCount(serial) {
			// alert(parseInt($('#segmentedit-global').val()));
			if (parseInt($('#segmentedit-global').val()) !== 1) {
				setCount();

				Adzuki.Ajax
					.post(
						Adzuki.base_uri + '/Segments/count/',
						serial
					)
					.then(
						function success(data) {
							setCount(data.matched);
						}
				);
			}
		}

		function setCount(count) {
			var panel = $('.bottom-panel');
			if (count) {
				panel.addClass('show');
				panel.find('.bottom-panel-result-count').text(count);
			} else {
				panel.find('.bottom-panel-result-count').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-pulse fa-fw"></i>');
			}
		}

		/**
		 * Takes object of input filters and builds html string to append to DOM for display
		 * @param {[array]}
		 */
		function setFilters(filters) {
			var html = '';

			$(filters)
				.each(
					function createHtml() {
						if (this.values.length > 0) {
							html +=  '<h4>'+this.title+'</h4>';
							$(this.values)
								.each(
									function addValue() {
										html += '<span class="btn btn-info btn-xs">'+this+'</span>';
									}
								)
							;
						}
					}
				)
			;

			if (html) {
				$('.segment .segment-filters').html('');
				$('.segment .segment-filters').append(html);
			} else {
				$('.segment .segment-filters').html('');
				html = '<div class="alert alert-info text-center" role="alert">No Filters selected.</div>';
				$('.segment .segment-filters').append(html);
			}

		}



		$('#segmentedit-future_credit_vendor_ids').change();
	};

}(jQuery, window.Adzuki || {}));